import { render, staticRenderFns } from "./OrganisationDashboard.vue?vue&type=template&id=7ba33afa"
import script from "./OrganisationDashboard.vue?vue&type=script&lang=js"
export * from "./OrganisationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports